import { cn } from '@/lib/utils';

interface ProgressBarProps {
  percentage: number;
  currentQuestion: number;
  totalQuestions: number;
  estimatedMinutes: number;
  className?: string;
}

export function ProgressBar({
  percentage,
  currentQuestion,
  totalQuestions,
  estimatedMinutes,
  className,
}: ProgressBarProps) {
  return (
    <div className={cn('space-y-2', className)}>
      {/* Progress bar */}
      <div className="h-2 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-primary transition-all duration-500 ease-out rounded-full"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      {/* Progress info */}
      <div className="flex justify-between text-sm text-muted-foreground">
        <span>
          Question {Math.min(currentQuestion + 1, totalQuestions)} of {totalQuestions}
        </span>
        <span>
          {estimatedMinutes > 0 
            ? `~${estimatedMinutes} min remaining`
            : 'Almost done'
          }
        </span>
      </div>
    </div>
  );
}
